import { api_configuration } from "../../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { addChild } from "../../../../../../destructables";
import DestructorTree from "../../DestructorTree";
import { registerQueryEntry } from "../../state/registerClientState";
import clientWorkIsDone from "../../state/tasks";
import { iCollection } from "../../state/Collection";

export function deleteCollectionEntry(entry: api_cs.Centries__collection): void {
	iCollection(entry.parent).deleteEntry(entry);
}

export async function deleteQueryEntry(qes: api_cs.Cquery_entry_status) {
	const initialized = qes.properties.initialized.state;
	switch (initialized.name) {
		case "yes":
			deleteCollectionEntry(
				initialized.node.properties.referenced_node.output.result_node().input.entity().cast("entry")
			);
			break;
		case "no": {
			const destructor = new DestructorTree();
			addChild(qes, destructor);
			const entry = registerQueryEntry(qes, destructor).input.entity().cast("entry");
			await clientWorkIsDone();
			deleteCollectionEntry(entry);
			break;
		}
		case "unknown":
	}
}
